const styles = {
  container: {
    position: "relative",
  },
  zoomHolder: {
    alignSelf: "end",
    "@media screen and (max-width: 1200px)": {
      display: "none",
    },
  },
  bottomMenu: {
    height: "32px",
    position: "fixed",
    bottom: "20px",
    right: "10px",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    "& > div": {
      marginLeft: "10px",
      marginRight: "10px",
    },
  },
  // This class will be passed to the MapActionButtons component to position it in the CampusMap component
  mapActionButtonsPosition: {
    position: "absolute",
    zIndex: 800, // Arbitrary
    top: 0,
    right: 10,
  },
  view: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },
  searchOptionsPosition: {
    position: "absolute",
    zIndex: 800, // Arbitrary
    top: 0,
    width: "100%",
    maxWidth: "286px",
    "@media (max-width: 1200px)": {
      maxWidth: "375px",
    },
  },
  shareMenu: {
    zIndex: 800,
    backgroundColor: "#FFFFFF",
  },
  // Portrait
  destinationsMobileContainer: {
    position: "absolute",
    zIndex: 800, // Arbitrary
    top: 17,
    left: 25,
  },
  trailsMobileContainer: {
    position: "absolute",
    zIndex: 800, // Arbitrary
    top: 17,
    left: 80,
  },
  iconContainer: {
    backgroundColor: "#FFF",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "50%",
    margin: "auto",
    height: "40px",
    width: "40px",
    display: "table",
  },
  verticalAlignContainer: {
    display: "table", // Ugly, but works in IE11.  When IE11 is disposed, then use flex
  },
  verticalAlignChild: {
    display: "table-cell",
    textAlign: "center",
    verticalAlign: "middle",
  },
  showSearchOptionsPositionMobile: {
    display: "block",
  },
  hideSearchOptionsPositionMobile: {
    display: "none",
  },
  hideMapActionButtonsPosition: {
    display: "none !important",
  },
  higherIndex: {
    zIndex: 980,
  },
  lowerIndex: {
    zIndex: 0,
  },
  mobileButtons: {
    position: "fixed",
    top: "20px",
    left: "24px",
    display: "none",
    zIndex: "800",
    "@media screen and (max-width : 1199px)": {
      display: "flex",
    },
    "& div:first-child": {
      marginRight: "16px",
    },
  },
  SearchAIButton: {
    margin: 0,
    border: 0,
    width: "40px",
    height: "42px",
    cursor: "pointer",
    paddingTop: "7px",
    marginRight: "10px",
    display: "flex",
    boxShadow: "0 4px 8px 0 rgb(0 0 0 / 20%)",
    alignItems: "center",
    borderRadius: "50%",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    "@media screen and (max-width : 1199px)": {
      paddingLeft: "6px",
    },
  },
};

export default styles;
